/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import moveEntityTemplate from '../admin/entity/move-entity.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

import MoveEntityController from '../admin/entity/move-entity.controller';

export default angular.module('agrolog.api.aeration', [])
    .factory('aerationService', AerationService)
    .name;

/*@ngInject*/
function AerationService($q, $mdDialog, $document, $filter, types, agTypes, agUserService, alarmService, entityService, assetService, entityRelationService) {

    var allAerationAttributesKeys = [];
    var allAerationRelationAttributesKeys = [];

    for (var attrId in agTypes.attributes.baseAsset) {
        var attr = agTypes.attributes.baseAsset[attrId];
        allAerationAttributesKeys.push(attr);
    }
    for (attrId in agTypes.attributes.aeration) {
        attr = agTypes.attributes.aeration[attrId];
        allAerationAttributesKeys.push(attr);
    }

    for (attrId in agTypes.attributes.aerationSystemRelation) {
        attr = agTypes.attributes.aerationSystemRelation[attrId];
        allAerationRelationAttributesKeys.push(attr);
    }

    var positionAttributeKeys = [];
    positionAttributeKeys.push(agTypes.attributes.baseAsset.positionX);
    positionAttributeKeys.push(agTypes.attributes.baseAsset.positionY);

    var service = {
        saveAeration: saveAeration,
        moveAerationDialog: moveAerationDialog,
        getAeration: getAeration,
        getAerationAssetUnits: getAerationAssetUnits,
        getAerationRelays: getAerationRelays,
        deleteAeration: deleteAeration,
        deleteAerationRelation: deleteAerationRelation,
        getAssetAerations: getAssetAerations,
        saveAssetAeration: saveAssetAeration,
        getAerationConnectedSystems: getAerationConnectedSystems,
        getMapAerationConnectedSystems: getMapAerationConnectedSystems
    }

    return service;

    function saveAeration(aeration, parentEntityId) {
        var deferred = $q.defer();
        var assign = !aeration.id.id;
        entityService.saveRelatedEntity(aeration, parentEntityId, allAerationAttributesKeys).then(
            function success(aeration) {
                if (assign) {
                    agUserService.assignAssetToCustomer(aeration).then(
                        (aeration) => {
                            deferred.resolve(aeration);
                        },
                        () => {
                            deferred.reject();
                        }
                    );
                } else {
                    deferred.resolve(aeration);
                }
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function moveAerationDialog($event, aeration, parentEntityId) {
        var deferred = $q.defer();
        if ($event) {
            $event.stopPropagation();
        }

        var placeholderText = 'ag.aeration.select-move-target-text';
        var notFoundText = 'ag.aeration.move-target-not-found-text';
        var requiredText = 'ag.aeration.move-target-requited-text';
        var targetEntitySubtypes = [agTypes.assetType.site, agTypes.assetType.siloGroup];

        agUserService.getAgrologCustomer().then(
            (agCustomer) => {
                var targetRootEntityId = agCustomer.id;
                $mdDialog.show({
                    controller: MoveEntityController,
                    controllerAs: 'vm',
                    templateUrl: moveEntityTemplate,
                    parent: angular.element($document[0].body),
                    locals: {
                        placeholderText: placeholderText,
                        notFoundText: notFoundText,
                        requiredText: requiredText,
                        parentEntityId: parentEntityId,
                        entity: aeration,
                        targetRootEntityId: targetRootEntityId,
                        targetEntityType: types.entityType.asset,
                        targetEntitySubtypes: targetEntitySubtypes
                    },
                    fullscreen: true,
                    targetEvent: $event
                }).then(function () {
                    deferred.resolve();
                }, function () {
                    deferred.reject();
                });
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getAeration(aerationId, includeGW) {
        var deferred = $q.defer();
        entityService.getRelatedEntity(aerationId, allAerationAttributesKeys, agTypes.assetTypeTranslatePrefix).then(
            function success(aeration) {
                if (includeGW) {
                    entityService.getRelatedEntities(aerationId, types.entityType.device, [agTypes.deviceType.gateway], 1, null, agTypes.deviceTypeTranslatePrefix,
                        null, types.entitySearchDirection.to).then(
                        function success(relatedGW){
                            aeration.gatewayDeviceId = relatedGW[0] ? relatedGW[0].id.id : null;
                            deferred.resolve(aeration);
                        },
                        function fail() {
                            deferred.reject();
                        }
                    );
                } else {
                    deferred.resolve(aeration);
                }
           },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getAerationAssetUnits(aerationId) {
        var deferred = $q.defer();
        getAerationRelays(aerationId).then(
            (relays) => {
                getAerationWeatherStations(aerationId).then(
                    (weatherStations) => {
                        var assetUnits = relays.concat(weatherStations);
                        deferred.resolve(assetUnits);
                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getAerationRelays(aerationId) {
        var deferred = $q.defer();
        entityService.getRelatedEntities(aerationId, types.entityType.device,
            [agTypes.deviceType.relay], 1, [], agTypes.deviceTypeTranslatePrefix, agTypes.relationType.relay).then(
            function success(devices) {
                deferred.resolve(devices);
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getAerationWeatherStations(aerationId) {
        var deferred = $q.defer();
        entityService.getRelatedEntities(aerationId, types.entityType.asset,
            [agTypes.assetType.weatherStation], 1, [], agTypes.assetTypeTranslatePrefix, agTypes.relationType.weatherStation).then(
            function success(weatherStations) {
                deferred.resolve(weatherStations);
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function deleteAeration(aerationId) {
        var deferred = $q.defer();
        assetService.deleteAsset(aerationId.id).then(
            function success() {
                deferred.resolve();
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function deleteAerationRelation(aerationId, assetId) {
        var deferred = $q.defer();
        entityRelationService.deleteRelation(aerationId.id, aerationId.entityType,
            agTypes.relationType.aerationSystem,
            assetId.id, assetId.entityType).then(
            function success() {
                deferred.resolve();
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getAssetAerations(assetId) {
        var deferred = $q.defer();
        entityService.getRelatedEntities(assetId, types.entityType.asset, [agTypes.assetType.aeration], 1, [],
            agTypes.assetTypeTranslatePrefix, agTypes.relationType.aerationSystem, types.entitySearchDirection.to).then(
            function success(aerations) {
                deferred.resolve(aerations);
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function saveAssetAeration(aeration, assetId) {
        var deferred = $q.defer();
        var relation = {
            from: aeration.id,
            to: assetId,
            type: agTypes.relationType.aerationSystem,
            additionalInfo: {}
        };
        for (var i=0; i< allAerationRelationAttributesKeys.length; i++) {
            var key = allAerationRelationAttributesKeys[i];
            relation.additionalInfo[key] = aeration[key];
        }
        entityService.saveRelatedEntity(aeration, assetId, allAerationAttributesKeys, relation, types.entitySearchDirection.to).then(
            function success(aeration) {
                for (var i=0; i< allAerationRelationAttributesKeys.length; i++) {
                    var key = allAerationRelationAttributesKeys[i];
                    aeration[key] = relation.additionalInfo[key];
                }
                deferred.resolve(aeration);
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getAerationConnectedSystems(aerationId, fetchAlarmsSeverity) {
        return fetchAerationConnectedSystems(aerationId, [], fetchAlarmsSeverity);
    }

    function getMapAerationConnectedSystems(aerationId, fetchAlarmsSeverity) {
        return fetchAerationConnectedSystems(aerationId, positionAttributeKeys, fetchAlarmsSeverity);
    }

    function fetchAerationConnectedSystems(aerationId, keys, fetchAlarmsSeverity) {
        var deferred = $q.defer();
        var connectedSystemsTasks = [];
        connectedSystemsTasks.push(entityService.getRelatedEntities(aerationId, types.entityType.asset, [agTypes.assetType.weatherStation], 1, keys,
            agTypes.assetTypeTranslatePrefix, agTypes.relationType.weatherStation, types.entitySearchDirection.from));
        connectedSystemsTasks.push(entityService.getRelatedEntities(aerationId, types.entityType.asset, [agTypes.assetType.silo], 1, keys,
            agTypes.assetTypeTranslatePrefix, agTypes.relationType.aerationSystem, types.entitySearchDirection.from));
        $q.all(connectedSystemsTasks).then(
            function success(connectedSystemsBody) {
                var connectedSystems = connectedSystemsBody[0].concat(connectedSystemsBody[1]);
                if (fetchAlarmsSeverity) {
                    var alarmsSeverityTasks = [];
                    for (var i=0;i<connectedSystems.length;i++) {
                        var connectedSystem = connectedSystems[i];
                        alarmsSeverityTasks.push(fetchConnectedSystemsAlarmSeverity(connectedSystem));
                    }
                    $q.all(alarmsSeverityTasks).then(
                        function success(siteAssets) {
                            deferred.resolve(siteAssets);
                        },
                        function fail() {
                            deferred.reject();
                        }
                    );
                } else {
                    deferred.resolve(connectedSystems);
                }
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function fetchConnectedSystemsAlarmSeverity(connectedSystem) {
        var deferred = $q.defer();
        alarmService.getAlarms(connectedSystem.id.entityType, connectedSystem.id.id, {limit: 1000}, null, types.alarmStatus.activeUnack, true).then(
            (alarmsObj) => {
                let res = $filter('filter')(alarmsObj.data, {originator: { id: connectedSystem.id.id } });
                if (res.length) {
                    connectedSystem.highestAlarmSeverity = 'CRITICAL';
                    connectedSystem.highestAlarmStatus = types.alarmStatus.activeUnack;
                }
                deferred.resolve(connectedSystem);
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }
}
